import { render, staticRenderFns } from "./cModalRegisterPay.vue?vue&type=template&id=588b1cb0&scoped=true"
import script from "./cModalRegisterPay.vue?vue&type=script&lang=js"
export * from "./cModalRegisterPay.vue?vue&type=script&lang=js"
import style0 from "./cModalRegisterPay.vue?vue&type=style&index=0&id=588b1cb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588b1cb0",
  null
  
)

export default component.exports